export const getAverageValue = array => {
  if (Array.isArray(array) && array.length > 0) {
    return array.reduce((sum, val) => sum + (parseFloat(val) || 0), 0) / array.length;
  }
  return 0;
};
